import axios from 'axios';
import { BACKEND_URL } from '../config_and_helpers/config';
import { logError, logInfo } from '../config_and_helpers/logger';

const LOG_CONTEXT = 'stock_item_scan_client';

/**
 * @param {*} errPayload
 * @returns {string[]}
 */
export const formatStockItemScanErrors = errPayload => {
  if (errPayload == null) return ['Request failed. Please try again.'];
  if (typeof errPayload === 'string') return [errPayload];
  if (Array.isArray(errPayload)) return errPayload.map(String);
  if (errPayload.detail) {
    return Array.isArray(errPayload.detail)
      ? errPayload.detail.map(String)
      : [String(errPayload.detail)];
  }
  const messages = [];
  Object.entries(errPayload).forEach(([key, value]) => {
    if (value == null) return;
    if (Array.isArray(value)) value.forEach(v => messages.push(`${key}: ${v}`));
    else messages.push(`${key}: ${String(value)}`);
  });
  return messages.length ? messages : ['Request failed. Please try again.'];
};

const fail = (error, op) => {
  const data = error.response?.data ?? error.message;
  logError(LOG_CONTEXT, `${op} failed`, data);
  return {
    success: false,
    status: error.response?.status,
    messages: formatStockItemScanErrors(data),
    error: data,
  };
};

/** GET /stock-items/public/{token}/ — no auth */
export const getPublicStockItem = async token => {
  try {
    logInfo(LOG_CONTEXT, 'getPublicStockItem start');
    const response = await axios.get(
      `${BACKEND_URL}stock-items/public/${encodeURIComponent(token)}/`
    );
    logInfo(LOG_CONTEXT, 'getPublicStockItem success', {
      stockItemId: response.data?.stock_item_id,
      alreadyOpen: response.data?.already_open,
    });
    return { success: true, data: response.data };
  } catch (error) {
    return fail(error, 'getPublicStockItem');
  }
};

/** POST /stock-items/public/{token}/open/ — no auth */
export const openPublicStockItem = async (token, { opened_by_name } = {}) => {
  try {
    logInfo(LOG_CONTEXT, 'openPublicStockItem start', {
      hasName: Boolean(opened_by_name),
    });
    const body = opened_by_name ? { opened_by_name } : {};
    const response = await axios.post(
      `${BACKEND_URL}stock-items/public/${encodeURIComponent(token)}/open/`,
      body
    );
    logInfo(LOG_CONTEXT, 'openPublicStockItem success', {
      stockItemId: response.data?.stock_item_id,
      openedJustNow: response.data?.opened_just_now,
    });
    return { success: true, data: response.data };
  } catch (error) {
    return fail(error, 'openPublicStockItem');
  }
};

/** GET /orders/{orderId}/stock-item-labels/ — lab auth */
export const getOrderStockItemLabels = async (token, orderId) => {
  try {
    logInfo(LOG_CONTEXT, 'getOrderStockItemLabels start', { orderId });
    const response = await axios.get(
      `${BACKEND_URL}orders/${orderId}/stock-item-labels/`,
      {
        headers: {
          Authorization: `Token ${token}`,
        },
      }
    );
    logInfo(LOG_CONTEXT, 'getOrderStockItemLabels success', {
      orderId: response.data?.order_id,
      labelCount: response.data?.labels?.length ?? 0,
    });
    return { success: true, data: response.data };
  } catch (error) {
    return fail(error, 'getOrderStockItemLabels');
  }
};
